import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { NotificacionesService } from '../../notificaciones.service'
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.css']
})
export class NotificacionesComponent implements OnInit {

  buttons: any = [{
    // text: 'Actualizar',
    // click: this.refreshData.bind(this),
    // icon: 'sync',
    // show: true
  }]
  allNotifications: any
  allNotificationsMaintenance: any
  allNotificationsReport: any
  allNotificationsNotes: any
  allNotificationsNotesConsultas: any
  allNotificationsRefacciones: any
  allNotificationsRefaccionesConsultas: any


  userData: any
  historyNotifications: any
  historyNotificationsMaintenance: any
  historyNotificationsReport: any
  historyNotificationsNotes: any
  historyNotificationsNotesConsultas: any
  historyNotificationsRefacciones: any

  loading: boolean = true

  dataFilter
  searchFilter
  private unSubscribe$ = new Subject<void>();

  constructor(private router: Router, public notificacionesService: NotificacionesService) { }

  ngOnInit() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.userData = {
      usuario_id: userInfo.usuario_id,
      client_id: userInfo.cliente_id
    }
    // this.loadFilter()
    this.loadTestNotification();
  }

  loadTestNotification() {
    this.loading = true
    let id = this.userData.usuario_id.toString();
    //Data de mantenimientos
    this.notificacionesService.getMaintenanceF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.historyNotificationsMaintenance = data
        this.allNotificationsMaintenance = this.historyNotificationsMaintenance.length
        this.loading = false
      })
    //Data de Reportes
    this.notificacionesService.getReportF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.historyNotificationsReport = data
        this.allNotificationsReport = this.historyNotificationsReport.length
        this.loading = false
      })

    //Data de Notas
    this.notificacionesService.getNotesF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.historyNotificationsNotes = data
        this.loading = false
        this.allNotificationsNotes = this.historyNotificationsNotes.length
      })

    //Data de Notas CONSULTAS
    this.notificacionesService.getNotesConsultasF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.historyNotificationsNotesConsultas = data
        this.loading = false
        this.allNotificationsNotesConsultas = this.historyNotificationsNotesConsultas.length
      })

    //Data de Notas CONSULTAS
    this.notificacionesService.getRefaccionesF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.historyNotificationsRefacciones = data
        this.loading = false
        this.allNotificationsRefacciones = this.historyNotificationsRefacciones.length
      })
  }

  viewHistoryNotifications() {
    this.notificacionesService.getHitoryNotifications(this.userData.user_id)
      .subscribe((response: any) => {


        if (response.success) {
          /*for (var i = 0; i < response.data.length; ++i) {
            response.data[i].detalle = JSON.parse(response.data[i].detalle)
          }*/

          this.historyNotifications = response.data

          this.loading = false
          this.allNotifications = this.historyNotifications.length
        }
      });

  }

  viewHistoryNotificationsMaintenance() {
    this.notificacionesService.getHistoryNotificationsMaintenance(this.userData.user_id)
      .subscribe((response: any) => {


        if (response.success) {
          this.historyNotificationsMaintenance = response.data
          this.loading = false
          this.allNotificationsMaintenance = this.historyNotificationsMaintenance.length
        }
      });
  }

  viewHistoryNotificationsReport() {
    this.notificacionesService.getHistoryNotificationsReport(this.userData.user_id)
      .subscribe((response: any) => {


        if (response.success) {
          this.historyNotificationsReport = response.data
          this.loading = false
          this.allNotificationsReport = this.historyNotificationsReport.length
        }
      });
  }

  viewHistoryNotificationsNotes() {
    this.notificacionesService.getHistoryNotificationsNotes(this.userData.user_id)
      .subscribe((response: any) => {

        if (response.success) {
          this.historyNotificationsNotes = response.data
          this.loading = false
          this.allNotificationsNotes = this.historyNotificationsNotes.length
        }
      });
  }

  viewHistoryNotificationsRefacciones() {
    this.notificacionesService.getHistoryNotificationsNotes(this.userData.user_id)
      .subscribe((response: any) => {

        if (response.success) {
          this.historyNotificationsNotes = response.data
          this.loading = false
          this.allNotificationsNotes = this.historyNotificationsNotes.length
        }
      });
  }

  refreshData() {
    this.loadTestNotification()
  }

  openNotification(notification) {
    let id = this.userData.usuario_id.toString();


    if (notification.tipo_notificacion == 4 || notification.tipo_notificacion == 6 || notification.tipo_notificacion == 7 || notification.tipo_notificacion == 14 || notification.tipo_notificacion == 15 || notification.tipo_notificacion == 22) {
      this.notificacionesService.updateStatusF(id, notification.notificacion_id.toString())
      this.router.navigate(['reportes', 'list', notification.detalle.report_id || notification.detalle.filters.report_id])
    }
    if (notification.tipo_notificacion == 8) {
      this.notificacionesService.updateStatusF(id, notification.notificacion_id.toString())
      this.router.navigate(['reportes', 'list', notification.detalle.id_maintenance])
    }
    if (notification.tipo_notificacion == 1 || notification.tipo_notificacion == 2 || notification.tipo_notificacion == 3 || notification.tipo_notificacion == 9 || notification.tipo_notificacion == 10 || notification.tipo_notificacion == 13 || notification.tipo_notificacion == 16 || notification.tipo_notificacion == 19 || notification.tipo_notificacion == 20 || notification.tipo_notificacion == 21 || notification.tipo_notificacion == 23 || notification.tipo_notificacion == 24 || notification.tipo_notificacion == 25 || notification.tipo_notificacion == 26) {
      this.notificacionesService.updateStatusF(id, notification.notificacion_id.toString())
      this.router.navigate(['mantenimientos', 'list', notification.detalle.id_maintenance])
    }
    if (notification.tipo_notificacion == 27 || notification.tipo_notificacion == 28) {
      this.notificacionesService.updateStatusF(id, notification.notificacion_id.toString())
      this.router.navigate(['consultas', 'detalle', notification.detalle])
    }
    // if (notification.tipo_notificacion == 29 || notification.tipo_notificacion == 30) {
    //   this.notificacionesService.updateStatusF(id, notification.notificacion_id.toString())
    //   this.router.navigate(['refacciones', 'detail',notification.detalle['tipo'] , notification.detalle['id']])
    // }
  }


  loadFilter() {
    let id = this.userData.usuario_id.toString();
    this.notificacionesService.getMaintenanceTodas(id, this.searchFilter)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.dataFilter = data
      })
  }

  deleteFilter() {
    // Swal({
    //   title: '¿Seguro quiere hacer esta acción?',
    //   text: 'Se marcaran todas las notificaciones como leídas',
    //   // text: "You won't be able to revert this!",
    //   // icon: 'warning',
    //   inputClass: 'warning',

    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Aceptar',
    //   cancelButtonText: 'Cancelar'
    // }).then((result) => {
    //   if (result.value) {

    //     this.notificacionesService.deleteNotificationUser(this.userData.usuario_id, this.dataFilter).then(res => {
    //       Swal(
    //         'Marcadas todas como leídas',
    //         '',
    //         'success'
    //       )
    //     }).catch(err => {
    //       console.warn(err);
    //       Swal(
    //         'Error',
    //         '',
    //         'warning'
    //       )
    //     })

    //   }
    // })
  }
  openReport(report) {
    let id = this.userData.usuario_id.toString();

    if (report.tipo_notificacion == 4 || report.tipo_notificacion == 6 || report.tipo_notificacion == 7 || report.tipo_notificacion == 14 || report.tipo_notificacion == 15 || report.tipo_notificacion == 22) {
      this.notificacionesService.updateStatusF(id, report.notificacion_id.toString())

      this.router.navigate(['reportes', 'list', report.detalle.report_id], { queryParams: { 'notification_id': report.notificacion_id, 't': new Date().getTime() } })

    }

    if (report.tipo_notificacion == 2 || report.tipo_notificacion == 3 || report.tipo_notificacion == 9 || report.tipo_notificacion == 10 || report.tipo_notificacion == 13) {

      this.router.navigate(['mantenimientos', 'list', report.detalle.id_maintenance], { queryParams: { 'notification_id': report.notification_id, 't': new Date().getTime() } })

    }

  }
}
